.root {
  width: 300px;
}

.rootSmall {
  width: 180px;
}

.storyWrapper {
  width: 100%;
  height: 572px;
  position: relative;

  > div {
    width: 100% !important;
    height: 572px;
  }

  > div > div:nth-child(2) {
    position: absolute !important;
    top: 0 !important;
    left: 0 !important;
    right: 0 !important;
    bottom: 0 !important;
    width: 100% !important;
    height: 100% !important;

    > * {
      width: 100% !important;
      height: 100% !important;
    }
  }

  img[alt='Story content'] {
    object-fit: cover !important;
    width: 100% !important;
    height: 100% !important;
  }

  > div > div:first-child {
    z-index: 10 !important;
  }

  > div > div:last-child {
    z-index: 10 !important;
  }
}

.shuffleButton {
  margin-top: 16px;
  display: flex;
  justify-content: center;
}

.rootSmall .storyWrapper {
  height: 353px;

  > div {
    height: 353px !important;
  }
}

.rootSmall .shuffleButton {
  margin-top: 8px;
}
